import Vue from 'vue';
import isArray from 'lodash/isArray';
import indexOf from 'lodash/indexOf';
import map from 'lodash/map';

import ProjectModule from './project.module';
import {createProject, loadProjects, removeProject, updateProject} from '../api/project.api';

export default {
    namespaced: true,
    state:      {
        projects: [],
    },
    getters:    {
        projects:         (state) => state.projects,
        loadProjectsById: (state, getters) => (projectId) => {
            return new Promise((resolve) => resolve(getters.projects.find((project) => project.id === projectId) || null));
        },
    },
    actions:    {
        async init({dispatch}) {
            return dispatch('loadProjects');
        },
        async createProject({commit, getters, rootGetters}, data) {
            const {clients} = rootGetters['user/me'];
            if (isArray(clients) && clients.length) {
                data.clientId = clients[0].id;
            }
            return createProject(data).then((data) => {
                commit('ADD_PROJECT', data);
                return data;
            })
        },
        async updateProject({commit}, data) {
            return updateProject(data).then((data) => commit('UPDATE_PROJECT', data))
        },
        async removeProject({commit}, projectId) {
            return removeProject(projectId).then((id) => commit('REMOVE_PROJECT', id))
        },
        async loadProjects({commit}) {
            return loadProjects().then((data) => {
                commit('SET_PROJECTS', data);
                return data;
            });
        },
    },
    mutations:  {
        SET_PROJECTS:   (state, projectsData) => state.projects = projectsData,
        ADD_PROJECT:    (state, projectData) => state.projects.push(projectData),
        UPDATE_PROJECT: (state, projectData) => {
            const index = indexOf(map(state.projects, (object) => object.id), projectData.id);
            Vue.set(state.projects, index, projectData);
        },
        REMOVE_PROJECT: (state, projectId) => {
            const index = indexOf(map(state.projects, (object) => object.id), projectId);
            if (index !== -1) {
                state.projects.splice(index, 1);
            }
        },
    },
    modules:    {
        project: ProjectModule
    }
}
